import React from 'react'
import { generateKey } from '../../utils/utils.js'

const HyperLink = ({ item, headingNum, index }) => {
    if (item.nodeType === "hyperlink") {
        return <span key={generateKey(index)} className={`about-col-${headingNum}`}>
            <a key={generateKey(index)}
                rel="noopener noreferrer"
                target="_blank"
                style={{ color: 'white' }}
                href={item.data.uri}>{item.content[0].value}</a></span>
    } else {
        return <span key={generateKey(index)} className={`about-col-${headingNum}`}>{item.value}</span>;
    }
}

const AboutInfo = (props) => {
    const { content, index } = props;
    if (content.nodeType === "paragraph" && content.content.length <= 1) {
        return content.content[0].value;
    } else if (content.nodeType.includes('heading') && content.content.length <= 1) {
        let headingNum = content.nodeType[content.nodeType.length - 1];
        const CustomTag = `h${headingNum}`;
        return <CustomTag key={generateKey(index)}>{content.content[0].value}</CustomTag>;
    } else if (content.content.length >= 1) {
        let headingNum = content.nodeType[content.nodeType.length - 1];
        let theEl = content.content.map((item, i) => (
            <HyperLink key={i} item={item} headingNum={headingNum} index={i} />
        ))
        return <div key={generateKey(index)} className="about--more">{theEl}</div>
    }
    else {
        return null;
    }
}

export default AboutInfo